import { Scan } from 'lucide-react';

import CTMonitoringFunctionalityDisabled from './CTMonitoringFunctionalityDisabled';
import UIStrings from '@/Utils/UIStrings';

interface CTMonitoringScreenshotsStubProps {
    isScreenSnapshotsEnabled?: boolean;
}

function CTMonitoringScreenshotsStub({ isScreenSnapshotsEnabled }: CTMonitoringScreenshotsStubProps) {
    return (
        <CTMonitoringFunctionalityDisabled
            icon={<Scan className="text-muted-foreground size-6" aria-hidden />}
            message={isScreenSnapshotsEnabled ? UIStrings.ScreenSnapshotsIsMissing : UIStrings.ScreenSnapshotsDisabled}
            className="h-96"
        />
    );
}

export default CTMonitoringScreenshotsStub;
